import { BrowserRouter } from "react-router-dom";
import Router from "./routes";

function App() {
  return (
    <BrowserRouter basename="/install/">
      <div style={{ marginLeft: 10, marginRight: 10, marginTop: 10 }}>
        <Router/>
      </div>
    </BrowserRouter>
  );
}

export default App;
